import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M145 5C67.6 5 5 67.6 5 145s62.6 140 140 140 140-62.6 140-140c.8-77.4-61.8-140-140-140zm74.1 149H70.9v-17.3h148.2V154z"
})), 'DeleteIcon');